/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldValidationErrorDto
 */
export interface FieldValidationErrorDto {
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorDto
     */
    field?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorDto
     */
    csvColumn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorDto
     */
    rawValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorDto
     */
    errorCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorDto
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorDto
     */
    validatorType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorDto
     */
    severity?: string | null;
}

/**
 * Check if a given object implements the FieldValidationErrorDto interface.
 */
export function instanceOfFieldValidationErrorDto(value: object): value is FieldValidationErrorDto {
    return true;
}

export function FieldValidationErrorDtoFromJSON(json: any): FieldValidationErrorDto {
    return FieldValidationErrorDtoFromJSONTyped(json, false);
}

export function FieldValidationErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldValidationErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'] == null ? undefined : json['field'],
        'csvColumn': json['csvColumn'] == null ? undefined : json['csvColumn'],
        'rawValue': json['rawValue'] == null ? undefined : json['rawValue'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'validatorType': json['validatorType'] == null ? undefined : json['validatorType'],
        'severity': json['severity'] == null ? undefined : json['severity'],
    };
}

export function FieldValidationErrorDtoToJSON(json: any): FieldValidationErrorDto {
    return FieldValidationErrorDtoToJSONTyped(json, false);
}

export function FieldValidationErrorDtoToJSONTyped(value?: FieldValidationErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'csvColumn': value['csvColumn'],
        'rawValue': value['rawValue'],
        'errorCode': value['errorCode'],
        'errorMessage': value['errorMessage'],
        'validatorType': value['validatorType'],
        'severity': value['severity'],
    };
}

